/**
 * Created by toomasp on 29.07.2015.
 */

export let filters = angular.module('eservice.core.filters', []);

import filterDefinitions from './FilterDefinitions';

for (let filterName in filterDefinitions) {
    filters.filter(filterName, filterDefinitions[filterName]);
}




// WEBPACK FOOTER //
// ./src/main/ui/core/filters/filters.ts